import { Component, OnInit, Injector } from '@angular/core';
import { TableAbstractComponent } from 'src/app/common-page-components/classes/table-abstract-component';
import { FilterCoachesService } from '../../services/filter-coaches.service';
import { CoachesStore } from 'src/app/common-page-components/stores/entities-store/coaches-store';
import { HttpClient } from '@angular/common/http';
import { combineLatest, map, mergeMap, filter, catchError } from 'rxjs/operators';
import { ICoaches } from '../../../common-page-components/stores/entities-store/coaches-store';
import { environment } from '@environments/environment';
import { of } from 'rxjs';
import { INews } from 'src/app/common-page-components/news-panel/news-panel.component';
import { Title } from '@angular/platform-browser';

/**
 *
 *
 * @export
 * @class BootstrapCoachesComponent
 * @extends {TableAbstractComponent}
 * @implements {OnInit}
 */
@Component({
  selector: 'app-bootstrap-coaches',
  templateUrl: './bootstrap-coaches.component.html',
  styleUrls: ['./bootstrap-coaches.component.scss']
})
export class BootstrapCoachesComponent extends TableAbstractComponent implements OnInit {
  /**
   * A news Array of athletes
   *
   * @type {Array<INews>}
   * @memberof BootstrapCoachesComponent
   */
  news: Array<INews>;

  /**
   * Headers of coaches table
   *
   * @memberof BootstrapCoachesComponent
   */
  headers = [
    { name: '', isSortable: false, sortProperty: '' },
    { name: 'Name', isSortable: true, sortProperty: 'NAME' },
    { name: "Country", isSortable: true, sortProperty: 'COUNTRY' },
    { name: 'Nationality', isSortable: true, sortProperty: 'NATIONALITY' },
    { name: 'Age', isSortable: true, sortProperty: 'TO DO' },

  ];
  constructor(injector: Injector, public filter_services: FilterCoachesService, http: HttpClient,  private titleService: Title) {
    super(injector, filter_services, new CoachesStore(http, injector));
    http.get(environment.news_api.athletes_spotligth).pipe(catchError(e=>of([]))).subscribe((next:any)=>{
      this.news = next as any;
    });
    this.titleService.setTitle('Coaches | World Archery');
    this.ShowNoResultsBox = true;
  }

  ngOnInit() {
    this.filter_services.getDataStreamWithFilters().pipe(
      combineLatest([this.reload.asObservable()]),
      map(([a, b]) => a),
      map(([order, text, active, country, archery_position]) => {
        const params = {
          SortBy: order.sortingSend,
          Name: text.text,
          Active: active.Value == null ? 0 : active.Value === true ? 1 : -1,
          Country: (country as any).NOC as any,
          Nationality: (archery_position as any).NOC as any,
        };
        if (this.checkParamsForShowMessage(params) === false) {
          this.model.data = [];
          this.model.loadingRef = false;
          this.model.pagination.totalResults = 0;
          this.ShowNoResultsBox = true;
          this.customLoadMsg = 'Search or filter by country or nationality to find coaches';
        } else {
          this.ShowNoResultsBox = false;
          this.customLoadMsg = 'No results';
        }
        return params;
      }),
      filter(a => this.checkParamsForShowMessage(a)),
      mergeMap(params => this.model.requestData(params, this.request_more_data))
    ).subscribe();
  }

  /**
   * A method for check if there's any correct param and send data.
   *
   * @param {*} params
   * @returns
   * @memberof BootstrapCoachesComponent
   */
  checkParamsForShowMessage(params: any) {
    return params.Nationality.toString().length > 0 || params.Country.toString().length > 0 || params.Name !== ''
  }

  /**
   * Method for get first country code of coache from NOC property
   *
   * @param {ICoaches} coache
   * @returns
   * @memberof BootstrapCoachesComponent
   */
  getCountryCode(coache: ICoaches) {
    return Object.keys(coache.NOC)[0];
  }

  /**
   * Method for get the name of the country
   *
   * @param {string} NOC
   * @returns
   * @memberof BootstrapCoachesComponent
   */
  getCountryName(NOC: string) {
    const flag = this.model.dependencies[0].entity.data.find(value => value.NOC === NOC);
    return flag ? flag.Cshort : '';
  }

}
